export default {
  modelName: 'Exercise',
  attributes: {
    createdAt: {
      name: "createdAt",
      apiName: "createdAt",
      camelName: "createdAt",
      underscoreName: "created_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Created At",
    },
    id: {
      name: "id",
      apiName: "id",
      camelName: "id",
      underscoreName: "id",
      type: "integer",
      writeable: false,
      default: null,
      humanName: "Id",
    },
    isMissingWeightMap: {
      name: "isMissingWeightMap",
      apiName: "missingWeightMap?",
      camelName: "isMissingWeightMap",
      underscoreName: "is_missing_weight_map",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Is Missing Weight Map",
    },
    name: {
      name: "name",
      apiName: "name",
      camelName: "name",
      underscoreName: "name",
      type: "string",
      writeable: true,
      default: null,
      humanName: "Name",
    },
    updatedAt: {
      name: "updatedAt",
      apiName: "updatedAt",
      camelName: "updatedAt",
      underscoreName: "updated_at",
      type: "datetime",
      writeable: true,
      default: null,
      humanName: "Updated At",
    },
    userId: {
      name: "userId",
      apiName: "userId",
      camelName: "userId",
      underscoreName: "user_id",
      type: "integer",
      writeable: true,
      default: null,
      humanName: "User",
    },
    weightMap: {
      name: "weightMap",
      apiName: "weightMap",
      camelName: "weightMap",
      underscoreName: "weight_map",
      type: "jsonb",
      writeable: true,
      default: "[]",
      humanName: "Weight Map",
    },
  },
  names: {
    model: "Birl::Exercise",
    base: "exercise",
    baseSingularClass: "Exercise",
    human: "Exercise",
    singularCamelFull: "birlExercise",
    singularCamel: "exercise",
    singularClassFull: "BirlExercise",
    singularClass: "Exercise",
    singularDash: "exercise",
    singularUnderscoreFull: "birl_exercise",
    singularUnderscore: "exercise",
    singularUnderscorePath: "birl/exercise",
    pluralModel: "Birl::Exercises",
    pluralCamelFull: "birlExercises",
    pluralCamel: "exercises",
    pluralClass: "Exercises",
    pluralDash: "exercises",
    pluralUnderscoreFull: "birl_exercises",
    pluralUnderscore: "exercises",
    pluralUnderscorePath: "birl/exercises",
  },
  validators: [
    {
      className: "ActiveRecord::Validations::PresenceValidator",
      options: {
        message: "required",
        if: null,
      },
      attributes: [
        "user",
      ],
    },
  ],
  enums: {
  },
}
